import { Component, Host, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DiFormService } from 'src/app/di-core/service/di-form-service/di-form.service';
import { DiFormComponent } from '../../di-form/di-form.component';

@Component({
  selector: 'di-datepicker',
  templateUrl: './di-datepicker.component.html',
  styleUrls: ['./di-datepicker.component.scss']
})
export class DiDatepickerComponent implements OnInit {
  @Input() placeholder: string;
  @Input() fcName: string;
  @Input() hintMessage: string;

  diForm: DiFormComponent
  formGroup: FormGroup;
  errorMessage: string;

  constructor(@Host() diForm: DiFormComponent, private formService: DiFormService) {
    let component = this;
    component.diForm = diForm;
  }
  ngOnInit(): void {
    let component = this;
    component.formService.initFormGroup$.subscribe(initFormGroup => {
      if (initFormGroup == component.diForm.formGroup) {
        component.formGroup = component.diForm.formGroup;
      }
    })
  }

}
